import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ProductsBanner() {
  const { t } = useTranslation();

  return (
    <section className="relative h-64 md:h-80 flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=multiple%20cat%20scratching%20boards%20and%20cat%20toys%20arranged%20beautifully%20on%20a%20warm%20beige%20surface%2C%20flat%20lay%20product%20photography%2C%20natural%20light%2C%20warm%20tones%2C%20minimalist%20composition%2C%20high%20quality%20pet%20product%20showcase%2C%20soft%20shadows&width=1440&height=400&seq=prodsbanner1&orientation=landscape"
          alt="Products"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/20"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 w-full">
        <div className="flex items-center gap-2 text-white/60 text-xs mb-4">
          <Link to="/" className="hover:text-white transition-colors cursor-pointer">{t('products_breadcrumb_home')}</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-white/90">{t('products_breadcrumb')}</span>
        </div>
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-3">{t('products_banner_title')}</h1>
        <p className="text-white/70 text-sm md:text-base max-w-md">
          {t('products_banner_desc')}
        </p>
      </div>
    </section>
  );
}